// Error handling utility to extract meaningful messages from API errors

export const extractErrorMessage = (error, fallback = 'خطای ناشناخته رخ داد') => {
  // If it's a plain string error
  if (typeof error === 'string') {
    return error;
  }
  
  // If it's an axios error with response
  if (error?.response?.data) {
    const data = error.response.data;
    
    // Common backend response structures
    if (data.message) {
      return data.message;
    }
    if (data.error) {
      return data.error;
    }
    if (data.detail) {
      return data.detail;
    }
    
    // Validation errors: { field: ['error message'] }
    if (typeof data === 'object' && !Array.isArray(data)) {
      const firstKey = Object.keys(data)[0];
      if (firstKey && Array.isArray(data[firstKey]) && data[firstKey].length > 0) {
        return data[firstKey][0];
      }
      // If it's just an object with string values
      const firstValue = Object.values(data)[0];
      if (typeof firstValue === 'string') {
        return firstValue;
      }
    }
  }
  
  // If error has a message property directly (like thrown Error)
  if (error?.message && typeof error.message === 'string') {
    // Filter out generic axios messages
    const genericMessages = [
      'Network Error',
      'Request failed with status code',
      'timeout of',
      'Exceeded timeout'
    ];
    const isGeneric = genericMessages.some(msg => error.message.includes(msg));
    if (!isGeneric) {
      return error.message;
    }
  }
  
  // Network/connection errors
  if (error?.code === 'ECONNABORTED' || error?.message?.includes('timeout')) {
    return 'درخواست زمان‌بر شد. لطفاً دوباره تلاش کنید.';
  }
  
  if (error?.message?.includes('Network Error') || !error?.response) {
    return 'خطای شبکه. لطفاً اتصال اینترنت خود را چک کنید.';
  }
  
  // Status code based messages (fallback when backend did not send a message)
  if (error?.response?.status) {
    switch (error.response.status) {
      case 400:
        return 'درخواست نادرست است.';
      case 401:
        return 'جلسه منقضی شده. لطفاً دوباره وارد شوید.';
      case 403:
        return 'دسترسی غیرمجاز.';
      case 404:
        return 'منبع یافت نشد.';
      case 500:
        return 'خطای سرور. لطفاً بعداً تلاش کنید.';
      case 502:
        return 'خطای سرویس پیامک. لطفاً دوباره تلاش کنید.';
      case 504:
        return 'زمان پاسخ‌دهی سرویس به پایان رسید. لطفاً دوباره تلاش کنید.';
      case 413:
        return 'حجم تصویر خودرو زیاد است. لطفاً تصویر کوچک‌تری انتخاب کنید.';
      default:
        return `خطا (${error.response.status})`;
    }
  }
  
  return fallback;
};

export const handleApiError = (error, setError, fallback = 'خطا در پردازش درخواست') => {
  const message = extractErrorMessage(error, fallback);
  if (setError) {
    setError(message);
  }
  return message;
};
